<div class="message-page">
  <div class="title-box">
    <span class="header-section">Welcome to VoiceBox</span>
  </div>
  <br>
  <mdb-card>
    <mdb-card-body class="pt-3 pb-0">      
      <span class="title-sub-section">Usage Stats (Last 30 Days)</span>
      <hr class="mt-1 mb-0">
      <div class="row">
        <div class="col">
          <app-stats-card 
            [headlineText]="'Total Contacts'" 
            [headlineNumber]="_dashboardStatsModel.totalContacts" 
            [faIconName]="'users'" 
            [percentageDifference]="_dashboardStatsModel.contactsPercentageDifference" 
            [faIconNameForPercentage]="getFaIconName(_dashboardStatsModel.contactsPercentageDifference)"             
            [colourForPercentage]="getPercentageColour(_dashboardStatsModel.contactsPercentageDifference)">
          </app-stats-card>
        </div>
        <div class="col">
          <app-stats-card 
            [headlineText]="'Email Sends'" 
            [headlineNumber]="_dashboardStatsModel.totalMessagesSent" 
            [faIconName]="'envelope'" 
            [percentageDifference]="_dashboardStatsModel.messagesPercentageDifference" 
            [faIconNameForPercentage]="getFaIconName(_dashboardStatsModel.messagesPercentageDifference)" 
            [colourForPercentage]="getPercentageColour(_dashboardStatsModel.messagesPercentageDifference)"></app-stats-card>
        </div>
        <div class="col">
          <app-stats-card 
            [headlineText]="'SMS Sends'"  
            [headlineNumber]="_dashboardStatsModel.totalSMSMessagesSent" 
            [faIconName]="'mobile-alt'" 
            [percentageDifference]="_dashboardStatsModel.smsPercentageDifference" 
            [faIconNameForPercentage]="getFaIconName(_dashboardStatsModel.smsPercentageDifference)" 
            [colourForPercentage]="getPercentageColour(_dashboardStatsModel.smsPercentageDifference)">
          </app-stats-card>
        </div>
      </div>    
      
      
    </mdb-card-body>                
  </mdb-card>  

  <mdb-card class="mt-4" hidden>
    <mdb-card-body class="pt-3 pb-0">    
      <span class="title-sub-section">Scheduled Automation Steps</span>
      <hr class="mt-1 mb-0">  
      <div class="row mt-2 mb-2 text-center">        
          <div class="col d-flex">
            <div class="card steps-box-size">
                <div class="card-body align-items-center d-flex justify-content-center">
                    <h5 class="card-title mb-0 bold-style">{{this._automationStepsCountsModel.DueEmails}}</h5>                        
                </div>
            </div>
            <div class="width-4rem ml-1 text-wrap align-items-center justify-content-center">
              Due today (Email)
            </div>
          </div>

          <div class="col d-flex">
            <div class="card steps-box-size">
                <div class="card-body align-items-center d-flex justify-content-center">
                    <h5 class="card-title mb-0 bold-style">{{this._automationStepsCountsModel.SentEmails}}</h5>                        
                </div>
            </div>
            <div class="width-4rem ml-1 text-wrap align-items-center justify-content-center">
              Sent today (Email)
            </div>
          </div>

          <div class="col d-flex">
            <div class="card steps-box-size">
                <div class="card-body align-items-center d-flex justify-content-center">
                    <h5 class="card-title mb-0 bold-style">{{this._automationStepsCountsModel.DueSMSs}}</h5>                        
                </div>
            </div>
            <div class="width-4rem ml-1 text-wrap align-items-center justify-content-center">
              Due today (SMS)
            </div>
          </div>

          <div class="col d-flex">
            <div class="card steps-box-size">
                <div class="card-body align-items-center d-flex justify-content-center">
                    <h5 class="card-title mb-0 bold-style">{{this._automationStepsCountsModel.SentSMSs}}</h5>                        
                </div>
            </div>
            <div class="width-4rem ml-1 text-wrap align-items-center justify-content-center">
              Sent today (SMS)
            </div>
          </div>
      </div>
    </mdb-card-body>                
  </mdb-card> 


  <mdb-card class="mt-4">
    <mdb-card-body class="pt-3 pb-0">    
      <div class="row align-items-center">
        <div class="col justify-content-start">
          <span class="title-sub-section">Scheduled Campaigns</span>
        </div>

        <div class="col d-flex justify-content-end">
          <div class="btn-group" role="group" aria-label="Filtering" (click)="onButtonGroupClick($event)">
            <button type="button" class="btn btn-link shadow-none active" (click)="getScheduledCampaigns(1)">TODAY</button>
            <button type="button" class="btn btn-link ml-5 shadow-none" (click)="getScheduledCampaigns(7)">7 DAYS</button>
            <button type="button" class="btn btn-link ml-5 shadow-none" (click)="getScheduledCampaigns(14)">14 DAYS</button>
          </div>
        </div>
      </div>
      <hr class="mt-1 mb-0">  
      <div class="row mt-2 mb-2 table-container-scroll" *ngIf="this._scheduledCampaignsRows.length">        
          <table mat-table [dataSource]="this._scheduledCampaignsDataSource" class="table-styles">

            <ng-container matColumnDef="Icon">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element"> 
                 <i *ngIf="element.MessageType == 1 || element.MessageType == 3" class="fa fa-envelope" aria-hidden="true"></i>
                 <i *ngIf="element.MessageType == 2" class="fa fa-comment" aria-hidden="true"></i>
              </td>
            </ng-container>

            <ng-container matColumnDef="MessageName">
              <th mat-header-cell *matHeaderCellDef>Message Name</th>
              <td mat-cell *matCellDef="let element">{{element.MessageName}}</td>
            </ng-container>

            <ng-container matColumnDef="ListName">
              <th mat-header-cell *matHeaderCellDef>List Name</th>
              <td mat-cell *matCellDef="let element">{{element.ListName}}</td>
            </ng-container>

            <ng-container matColumnDef="ScheduledDate">
              <th mat-header-cell *matHeaderCellDef>Scheduled Date</th>
              <td mat-cell *matCellDef="let element">{{this._datePipe.transform(element.ScheduledDate, 'medium')}}</td>
            </ng-container>

            <ng-container matColumnDef="Preview">
              <th mat-header-cell *matHeaderCellDef>Preview</th>
              <td mat-cell *matCellDef="let element">
                <button type="button" class="btn btn-link buttons-styles" (click)="viewMessage(element)">View Message</button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="this._scheduledCampaignsDisplayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: this._scheduledCampaignsDisplayedColumns;"></tr>
          </table>          
      </div>      
      <div *ngIf="!this._scheduledCampaignsRows.length" class="row mt-2 mb-2 justify-content-center">
        <span class="label-no-data">No data to display.</span>
      </div>
    </mdb-card-body>                
  </mdb-card> 

  <mdb-card class="mt-4 mb-4">
    <mdb-card-body class="pt-3 pb-0">    
      <div class="row align-items-center">
        <div class="col justify-content-start">
          <span class="title-sub-section">Previous Campaigns</span>
        </div>

        <div class="col d-flex justify-content-end">
          <div class="btn-group" role="group" aria-label="Filtering" (click)="onButtonGroupClick($event)">
            <button type="button" class="btn btn-link shadow-none active" (click)="getPreviousCampaigns(1)">TODAY</button>
            <button type="button" class="btn btn-link ml-5 shadow-none" (click)="getPreviousCampaigns(7)">7 DAYS</button>
            <button type="button" class="btn btn-link ml-5 shadow-none" (click)="getPreviousCampaigns(14)">14 DAYS</button>
          </div>
        </div>
      </div>
      <hr class="mt-1 mb-0">  
      <div class="row mt-2 mb-2 table-container-scroll" *ngIf="this._previousCampaignsRows.length">        
          <table mat-table [dataSource]="this._previousCampaignsDataSource" class="table-styles">

            <ng-container matColumnDef="Icon">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element"> 
                 <i *ngIf="element.MessageType == 1 || element.MessageType == 3" class="fa fa-envelope" aria-hidden="true"></i>
                 <i *ngIf="element.MessageType == 2" class="fa fa-comment" aria-hidden="true"></i>
              </td>
            </ng-container>

            <ng-container matColumnDef="MessageName">
              <th mat-header-cell *matHeaderCellDef>Message Name</th>
              <td mat-cell *matCellDef="let element">{{element.MessageName}}</td>
            </ng-container>

            <ng-container matColumnDef="ListName">
              <th mat-header-cell *matHeaderCellDef>List Name</th>
              <td mat-cell *matCellDef="let element">{{element.ListName}}</td>
            </ng-container>

            <ng-container matColumnDef="ScheduledDate">
              <th mat-header-cell *matHeaderCellDef>Scheduled Date</th>
              <td mat-cell *matCellDef="let element">{{this._datePipe.transform(element.ScheduledDate, 'medium')}}</td>
            </ng-container>

            <ng-container matColumnDef="Actions">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let element">
                <button type="button" class="btn btn-link buttons-styles" (click)="viewReport(element)">View Report</button> 
                <button type="button" class="btn btn-link buttons-styles" (click)="viewMessage(element)">View Message</button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="this._previousCampaignsDisplayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: this._previousCampaignsDisplayedColumns;"></tr>
          </table>
      </div>
      <div *ngIf="!this._previousCampaignsRows.length" class="row mt-2 mb-2 justify-content-center">
        <span class="label-no-data">No data to display.</span>
      </div>
    </mdb-card-body>                
  </mdb-card> 
  
</div>